import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FaSearch, FaTruck, FaCheckCircle, FaTimesCircle, FaUndo, FaFileInvoice, FaStar } from "react-icons/fa";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import api from '../axios/axios';
import { setAllOrders } from "../redux/features/auth/userSlice";
import Spinner from "../utils/Spinner";

const OrderHistory = () => {
  const [search, setSearch] = useState("");
  const currentUser = useSelector((state) => state.user.currentUser);
  const orders = useSelector((state) => state.user.orders);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (currentUser) {
      fetchOrders();
    } else {
      navigate('/login');
    }
  }, [currentUser]);

  const fetchOrders = async () => {
    setLoading(true);

    try {
      const response = await api.get('user/fetchOrders', {
        params: { id: currentUser._id },
      });
      dispatch(setAllOrders(response.data.orders));
      setLoading(false);
    } catch (error) {
      setError('Failed to fetch orders. Please try again later.');
      setLoading(false);
    }
  };

  const filteredOrders = orders.filter(order => 
    order._id.includes(search) || order.status.toLowerCase().includes(search.toLowerCase())
  );
if(loading)return <><Spinner/></>
  return (
    <>
      <Navbar />
      <motion.div className="max-w-6xl mx-auto p-6 bg-white shadow-lg rounded-lg border border-gray-200 mt-20 md:mt-24 ">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Order History</h2>
        
        <div className="mb-4 flex items-center border p-2 rounded-lg bg-gray-100">
          <FaSearch className="text-gray-500 mr-2" />
          <input
            type="text"
            placeholder="Search by Order ID or Status"
            className="w-full bg-transparent outline-none"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        
        {loading ? (
          <p>Loading orders...</p>
        ) : error ? (
          <p className="text-red-500">{error}</p>
        ) : (
          <div className="space-y-4 ">
            {filteredOrders?.map((order) => (
              <motion.div 
                key={order._id} 
                className="p-4 border rounded-lg shadow cursor-pointer bg-gray-50 hover:bg-gray-100 transition-all overflow-x-scroll"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                onClick={() => navigate(`/userorderdetail/${order._id}`)}

              >
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center border-b pb-2">
                  <div>
                    <p className="font-semibold text-lg">Order #{order._id}</p>
                    <p className="text-gray-500 text-sm">{new Date(order.createdAt).toLocaleDateString()}</p>
                  </div>
                  <span 
                    className={`px-3 py-1 mt-2 md:mt-0 rounded-full text-white ${
                      order.status === "Delivered" ? "bg-green-500" :
                      order.status === "Shipped" ? "bg-blue-500" : "bg-yellow-500"
                    }`}
                  >
                    {order.status}
                  </span>
                </div>
                
                <div className="mt-2">
                  <p className="text-gray-700 text-sm">Items: {order.itemCount}</p>
                </div>
                
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center mt-3">
                  <p className="text-gray-700 text-sm">Transaction ID: {order.transactionId}</p>
                </div>
                
                <div className="mt-3">
                  <p className="text-gray-700 text-sm">Shipping to: {order.selectedAddress.address}, {order.selectedAddress.city}, {order.selectedAddress.province}, {order.selectedAddress.postalCode}</p>
                </div>
                
                <div className="mt-3 flex flex-wrap gap-3">
                  {order.status === "paid" && (
                    <button className="px-4 py-2 bg-yellow-500 text-white rounded-lg flex items-center gap-2 hover:bg-yellow-600">
                      <FaTruck /> Track Order
                    </button>
                  )}
                  {order.status === "Delivered" && (
                    <button className="px-4 py-2 bg-green-500 text-white rounded-lg flex items-center gap-2 hover:bg-green-600">
                      <FaCheckCircle /> Reorder
                    </button>
                  )}
                  {order.status === "Shipped" && (
                    <button className="px-4 py-2 bg-red-500 text-white rounded-lg flex items-center gap-2 hover:bg-red-600">
                      <FaTimesCircle /> Cancel Order
                    </button>
                  )}
                  {order.status === "Delivered" && (
                    <button className="px-4 py-2 bg-blue-500 text-white rounded-lg flex items-center gap-2 hover:bg-blue-600">
                      <FaUndo /> Return Order
                    </button>
                  )}
                  <button className="px-4 py-2 bg-gray-500 text-white rounded-lg flex items-center gap-2 hover:bg-gray-600">
                    <FaFileInvoice /> Download Invoice
                  </button>
                  <button className="px-4 py-2 bg-orange-500 text-white rounded-lg flex items-center gap-2 hover:bg-orange-600">
                    <FaStar /> Rate Order
                  </button>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </motion.div>
      <Footer />
    </>
  );
};

export default OrderHistory;
